import React, { FC, PropsWithChildren } from 'react';
import classnames from 'classnames';

import styles from './_Caption.module.css';

interface CaptionProps {
    className?: string;
    title: string;
    subtitle?: string;
    subtitleLines?: 1 | 2 | 3 | 4 | 5;
    dot?: boolean;
}

export const Caption: FC<PropsWithChildren<CaptionProps>> = ({
    title,
    subtitle,
    className,
    dot = false,
    subtitleLines = 1,
    children,
}) => (
    <figcaption className={classnames(styles.root, className)}>
        <span className={classnames(styles.title, { [styles.dot]: dot })}>{title}</span>

        {subtitle && (
            <span
                className={classnames(
                    styles.subtitle,
                    styles.clamp,
                    styles[`clamp_lines_${subtitleLines}`]
                )}
                title={subtitle}
            >
                {subtitle}
            </span>
        )}

        {children}
    </figcaption>
);
